import { ApiService } from '@/services/api.services';
import { useEffect, useState } from 'react';

export const useMenus = () => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMenus = async () => {
      try {
        // PARALLEL FETCH
        const [aboutRes, servicesList] = await Promise.all([
          ApiService.getAboutPages(),
          ApiService.getServicesList(),
        ]);

        const dataAbout = aboutRes.data;
        const dataServicesList = servicesList.data;

        /* =======================
         * TENTANG KAMI
         * ======================= */
        const tentangKamiItems = dataAbout
          .sort((a, b) => a.position - b.position)
          .map((item) => ({
            name: item.title,
            slug: item.slug,
          }));

        /* =======================
         * PRODUK & LAYANAN
         * ======================= */

        const produkLayananList = dataServicesList
          .filter((service) => service.is_active)
          .sort((a, b) => a.position - b.position)
          .map((service) => ({
            title: service.title,
            slug: service.slug,
            items:
              service.items
                ?.filter((item) => item.is_active)
                .sort((a, b) => a.position - b.position)
                .map((item) => ({
                  name: item.title,
                  slug: item.slug,
                })) || [],
          }));

        /* =======================
         * BUILD FINAL MENUS
         * ======================= */
        setMenus([
          { name: 'Beranda', link: '/' },

          {
            name: 'Tentang Kami',
            subMenu: [
              {
                title: 'Profil',
                items: tentangKamiItems.map((item) => ({
                  name: item.name,
                  link: `/tentang-kami/profil/${item.slug}`,
                })),
              },
            ],
          },

          {
            name: 'Produk & Layanan',
            subMenu: produkLayananList.map((service) => ({
              title: service.title,
              items: service.items.length
                ? service.items.map((item) => ({
                    name: item.name,
                    link: `/produk-layanan/${service.slug}/${item.slug}`,
                  }))
                : [
                    {
                      name: `Tentang ${service.title}`,
                      link: `/produk-layanan/${service.slug}`,
                    },
                  ],
            })),
          },

          { name: 'Berita', link: '/berita' },
          { name: 'Karir', link: '/karir' },
        ]);
      } catch (error) {
        console.error('Gagal memuat menu', error);
      } finally {
        setLoading(false);
      }
    };

    loadMenus();
  }, []);

  return { menus, loading };
};
